import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import $ from 'jquery';
import './Leftsidebar.css';
import { AuthConsumer } from '../../contexts/Auth';
import { Translate } from '../../contexts/Language';

let activeTab = window.location.pathname.replace('/', '');

if (activeTab.indexOf('/'))
    activeTab = activeTab.split('/')[0];

class SideBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Tab: activeTab
        };
    }
    setActiveTab = (tab) => {
        this.setState({ Tab: tab });
        if ($(window).width() < 1025)
            $('body').addClass('enlarged');
    }
    componentDidMount() {

        if ($(window).width() < 1025) {
            $('body').addClass('enlarged');
        } else {
            $('body').removeClass('enlarged');

        }

        $('.button-menu-mobile').on('click', function (event) {
            event.preventDefault();
            $("body").toggleClass("enlarged");
        });
    }

    render() {
        return (
            <AuthConsumer>
                {({ onLogout }) => (
                    <div className="left side-menu">
                        <Scrollbars autoHide >
                            <div>
                                <div id="sidebar-menu">
                                    <ul className="metismenu" id="side-menu">
                                        <li className="menu-title">Main</li>
                                        <li>
                                            <Link to="/home" className={this.state.Tab === 'home' || this.state.Tab === '' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'home')}>
                                                <i className="fas fa-home"></i> <span> {Translate('Home')} </span>
                                            </Link>
                                        </li>
                                        <li className="menu-title">{Translate('Money Transfer')}</li>
                                        <li>
                                            <Link to="/withdrawal" className={this.state.Tab === 'withdrawal' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'withdrawal')}>
                                                <i className="fas fa-money-bill-alt"></i><span> {Translate('Withdrawal')} </span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/deposit" className={this.state.Tab === 'deposit' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'deposit')}>
                                                <i className="fas fa-coins"></i><span> {Translate('Deposit')} </span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/internal-transfer" className={this.state.Tab === 'internal-transfer' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'internal-transfer')}>
                                                <i className="fas fa-exchange-alt"></i><span> {Translate('Internal Trasfer')} </span>
                                            </Link>
                                        </li>
                                        <li className="menu-title">{Translate('Crypto')}</li>
                                        <li>
                                            <Link to="/crypto-wallet" className={this.state.Tab === 'crypto-wallet' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'crypto-wallet')}>
                                                <i className="fas fa-wallet"></i><span> {Translate('Wallet')} </span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/crypto-erc20wallet" className={this.state.Tab === 'crypto-erc20wallet' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'crypto-erc20wallet')}>
                                                <i className="fas fa-wallet"></i><span> {Translate('ERC20 Wallet')} </span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/crypto-trc20wallet" className={this.state.Tab === 'crypto-trc20wallet' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'crypto-trc20wallet')}>
                                                <i className="fas fa-wallet"></i><span> {Translate('TRC20 Wallet')} </span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/crypto-qrcode" className={this.state.Tab === 'crypto-qrcode' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'crypto-qrcode')}>
                                                <i className="fas fa-qrcode"></i><span> {Translate('QR Code')} </span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/coin-address-list" className={this.state.Tab === 'coin-address-list' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'coin-address-list')}>
                                                <i className="fas fa-list"></i><span> {Translate('Coin Adress List')} </span>
                                            </Link>
                                        </li>
                                        <li className="menu-title">{Translate('Transfer Options')}</li>
                                        <li>
                                            <Link to="/payment-services" className={this.state.Tab === 'payment-services' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'payment-services')}>
                                                <i className="fas fa-money-check-alt"></i><span> {Translate('Payment Services')} </span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/rules" className={this.state.Tab === 'rules' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'rules')}>
                                                <i className="fas fa-list"></i><span> {Translate('PSP Rules')} </span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/daily-limit" className={this.state.Tab === 'daily-limit' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'daily-limit')}>
                                                <i className="fas fa-calendar-day"></i><span> {Translate('PSP Daily Limit')} </span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/white-list" className={this.state.Tab === 'white-list' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'white-list')}>
                                                <i className="fas fa-user-check"></i><span> {Translate('White List')} </span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/black-list" className={this.state.Tab === 'black-list' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'black-list')}>
                                                <i className="fas fa-user-times"></i><span> {Translate('Black List')} </span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/page-role" className={this.state.Tab === 'page-role' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'page-role')}>
                                                <i className="fas fa-copy"></i><span> {Translate('Page Role')} </span>
                                            </Link>
                                        </li>
                                        <li className="menu-title">Common</li>
                                        <li>
                                            <Link to="/customer-documents" className={this.state.Tab === 'customer-documents' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'customer-documents')}>
                                                <i className="fas fa-copy"></i><span> Customer Documents </span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/users" className={this.state.Tab === 'users' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'users')}>
                                                <i className="fas fa-users"></i><span> Users </span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/settings" className={this.state.Tab === 'settings' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'settings')}>
                                                <i className="fas fa-cog"></i><span> Settings </span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/currency-settings" className={this.state.Tab === 'currency-settings' ? 'waves-effect active' : 'waves-effect'} onClick={this.setActiveTab.bind(this, 'currency-settings')}>
                                                <i className="fas fa-money-check-alt"></i><span> Currency Settings </span>
                                            </Link>
                                        </li>
                                        <li>
                                            <a href="#top" className="waves-effect" onClick={(e) => onLogout(e)}>
                                                <i className="ti-power-off"></i><span> Logout </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        </Scrollbars>
                    </div>
                )}
            </AuthConsumer>


        );
    }
}

export default SideBar;